import React from "react";
import { default as Spinner, SpinnerProps } from "react-spinkit";

interface IProps {
    // accepts values full (the default), half, quarter, and none for one second, a half second, a quarter second, and no fade in, respectively
    fadeIn?: SpinnerProps["fadeIn"];
}

interface IState {}

// TODO(ssr, LEVEL 1 out of 10): Migrate this component from class-style to functional-style. Rated LOE as 1/10 due to simple wrapper component with no state or lifecycle methods.
export class LoadingSpinner extends React.Component<IProps, IState> {
    render() {
        const _Spinner = Spinner as React.ComponentClass<SpinnerProps>;
        return (
            // TODO(i18n): Add aria-label for screen readers: aria-label={t`Loading`}
            <div className="loading-spinner l-capped-width">
                <div className="loading-spinner__inner">
                    <_Spinner
                        name="three-bounce"
                        fadeIn={this.props.fadeIn ? this.props.fadeIn : "full"}
                    />
                </div>
            </div>
        );
    }
}

export default LoadingSpinner;
